import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";
import { Sizes } from "@snapchat/snap-design-system-icons";

export const UpdateMessageLine = styled.span`
    display: flex;
    align-items: center;

    margin-top: 4px;

    font-size: ${FontSizeInPx.COMPACT}px;
    font-weight: ${FontWeight.MEDIUM};
    line-height: 20px;
    color: ${Colors.Black.V50};

    svg {
        width: ${Sizes.Small}px;
        height: ${Sizes.Small}px;
        margin-right: ${Spacing["2XS"] + Spacing["3XS"]}px;
        margin-left: 1px;
    }
`;
